/* oxlint-disable typescript/no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';
import { createProject as createProjectService, TCreateProjectRequest } from 'shared/services/createProject';
import { showAlert } from 'shared/slices/admin/alert';
import { EAlert } from 'shared/types/alert';

export const createProject = createAsyncThunk<boolean, TCreateProjectRequest, IThunkApi>(
  'projects/create',
  async (params, { extra: context, dispatch, rejectWithValue }) => {
    try {
      const isCreated = await createProjectService(context, params);

      if (isCreated) {
        dispatch(showAlert({ message: 'Проект успешно создан', type: EAlert.Info }));
      } else {
        dispatch(showAlert({ message: 'Проект не создан', type: EAlert.Error }));
      }

      return isCreated;
    } catch (_) {
      dispatch(showAlert({ message: 'Проект не создан', type: EAlert.Error }));

      return rejectWithValue(false);
    }
  },
  {
    /**
     * Можно предотвратить вызов thunk-а через специальный объект с условием
     * (полезно, например, в случаях, если идет загрузка и надо предотвратить повторный запрос)
     */
    // condition: (params, _api) => {
    //   /**
    //    * В api есть стейт и extra
    //    *
    //    * сonst { getState, extra } = api;
    //    */
    //   const { getState } = _api;
    //   const {
    //     demo: { test },
    //   } = getState();
    //   return test;
    // },
  },
);
